export const envelopeIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
     fill="none">
  <path
    d="M20 4.43945H4C2.9 4.43945 2.01 5.33945 2.01 6.43945L2 18.4395C2 19.5395 2.9 20.4395 4 20.4395H20C21.1 20.4395 22 19.5395 22 18.4395V6.43945C22 5.33945 21.1 4.43945 20 4.43945ZM20 8.43945L12 13.4395L4 8.43945V6.43945L12 11.4395L20 6.43945V8.43945Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
